import { render, staticRenderFns } from "./purchaseRow.vue?vue&type=template&id=bcdaff84&scoped=true&"
import script from "./purchaseRow.vue?vue&type=script&lang=js&"
export * from "./purchaseRow.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRow.vue?vue&type=style&index=0&id=bcdaff84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdaff84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
